import { Box } from '@primer/react';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MeetingHistory from './MeetingHistory';
import ClbNgoaiKhoaNavigation from './MeetingNavigation';
import MeetingPage from './MeetingPage';

const MeetingLayout = () => {
    const { tab } = useParams();
    const navigate = useNavigate();
    const selectedTab = useMemo(() => {
        if (tab === "ket-qua") {
            return "ket-qua";
        }
        return "clb";
    }, [tab])
    return (
        <Box sx={{
            p: 3,
            pt: 2
        }}>
            <Box sx={{ mb: 2 }}>
                <ClbNgoaiKhoaNavigation
                    selectedTab={selectedTab}
                    onSelectedChanged={(tab) => {
                        navigate("../../meeting/" + tab);
                    }}
                />
            </Box>
            {selectedTab === "clb" &&
                <MeetingPage />
            }
            {selectedTab === "ket-qua" &&
                <MeetingHistory />
            }
        </Box>
    );
};

export default MeetingLayout;